import React, { useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useLexicalComposerContext } from '@lexical/react/LexicalComposerContext';
import { CLEAR_EDITOR_COMMAND, type EditorState } from 'lexical';
import { faSend } from '@soundxyz/font-awesome/pro-solid-svg-icons/index.mjs';
import { useStableCallback } from '@soundxyz/graphql-react-query/utils';
import { LexicalUtils } from '@components/Lexical/utils';
import { Spinner } from '@components/basics/Spinner';

export function SendButtonPlugin({
  loading,
  onSubmit,
}: {
  loading: boolean;
  onSubmit: (editorState: EditorState) => void;
}) {
  const [editor] = useLexicalComposerContext();
  const [textLength, setTextLength] = React.useState(0);

  const onSubmitIntercept = useStableCallback(() => {
    editor.dispatchCommand(CLEAR_EDITOR_COMMAND, undefined);
    onSubmit(editor.getEditorState());
  });

  useEffect(() => {
    return editor.registerUpdateListener(({ editorState }) => {
      const count = LexicalUtils.getNodeTextLength(LexicalUtils.getRootNode(editorState));
      setTextLength(count);
    });
  }, [editor]);

  return (
    <div className="absolute bottom-0 right-0 top-0 z-above1 flex  aspect-square items-center justify-center">
      {loading ? (
        <Spinner size="sm" className=" text-neutral300" />
      ) : (
        <button
          className={`bottom-0 right-0 flex aspect-square h-7 w-7 items-center justify-center  rounded-full ${
            textLength ? 'bg-base800 hover:bg-base800/90' : 'bg-base800/30'
          }`}
          type="submit"
          onClick={onSubmitIntercept}
        >
          <FontAwesomeIcon icon={faSend} size="sm" className="text-white" />
        </button>
      )}
    </div>
  );
}
